import React, { useState, useEffect } from "react";
import api from "../lib/api.ts";
import { useLanguage } from "../context/LanguageContext.jsx";
import { Loader2 } from "lucide-react";

const Privacy = () => {
  const [privacyData, setPrivacyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { language, translate } = useLanguage();

  const isRTL = language === "ar";

  const fetchPrivacyData = async () => {
    try {
      setLoading(true);
      const lang = isRTL ? "ar" : "en";

      const response = await api.get(`/pagesettings/privacy-policy?lang=${lang}`);

      setPrivacyData(response.data.privacy_policy || []);
    } catch (error) {
      console.error("Error fetching privacy policy:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrivacyData();
  }, [language]);

  return (
    <div>
      {loading ? (
        <div className="flex flex-col items-center justify-center py-20">
          <Loader2 className="animate-spin text-blue-500" size={48} />
          <p className="mt-4 text-gray-400">
            {translate("common.loading") || "Loading privacy policy..."}
          </p>
        </div>
      ) : (
        <>
          {/* Page Heading */}
          <div className="w-full bg-primary border-b-2 border-gray px-6 py-4 mb-8 min-h-[120px]">
            <div className="max-w-[1600px] mx-auto">
              <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
                {translate("privacy.title")}
              </h1>
              <p className="text-description mb-4">
                {translate("privacy.description")}
              </p>
            </div>
          </div>

          {/* Privacy Content */}
          <div className="px-6">
            <div className="max-w-[1600px] mx-auto">

          {privacyData?.length > 0 ? (
  privacyData.map((item, index) => {
    // Check if all main fields are empty
    const allEmpty =
      (!item.title?.value || item.title.value.trim() === "") &&
      (!item.description?.value || item.description.value.trim() === "") &&
      (!item.imageUrl?.value || item.imageUrl.value.trim() === "");

    if (allEmpty) {
      return (
        <div
          key={index}
          className="flex flex-col items-center justify-center py-20"
        >
          <p className="text-gray-400 text-center">
            {translate("privacy.noPrivacyPolicy") || "No privacy policy found."}
          </p>
        </div>
      );
    }

    return (
      <div key={index} className="mb-10 bg-card rounded overflow-hidden">
        {/* Optional Image */}
        {item.imageUrl?.value && (
          <img
            src={item.imageUrl.value}
            alt={item.title?.value || "Privacy Image"}
            className="w-full object-cover rounded-t"
          />
        )}

        <div className="p-8">
          {/* Title */}
          {item.title?.value && (
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white">
              {item.title.value}
            </h2>
          )}

          {/* Description */}
          {item.description?.value && (
            <div
              className="max-w-none text-description [&_h1]:text-3xl 
                [&_h2]:text-2xl 
                [&_h3]:text-xl 
                [&_h4]:text-lg 
                [&_ul]:list-disc [&_ul]:ml-6 [&_ul]:mb-4
                [&_ol]:list-decimal [&_ol]:ml-6 [&_ol]:mb-4
                [&_li]:mb-1"
              dangerouslySetInnerHTML={{ __html: item.description.value }}
            />
          )}
        </div>
      </div>
    );
  })
) : (
  <div className="flex flex-col items-center justify-center py-20">
    <p className="text-gray-400 text-center">
      {translate("privacy.noPrivacyPolicy") || "No privacy policy found."}
    </p>
  </div>
)}

            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Privacy;